export function AddSortCriteria(sortConfig, fieldDef, sortOrder) {
  //TODO: rescope to sortConfig
  if (fieldDef != null) {
    var nameStr = fieldDef.GetFieldDisplayName();
    var idStr = fieldDef.GetFieldID();
    sortConfig.AddCriteria(idStr, nameStr, sortOrder);
  }
}
